import { render, staticRenderFns } from "./iconP10.vue?vue&type=template&id=6846a6d6&scoped=true&"
import script from "./iconP10.vue?vue&type=script&lang=js&"
export * from "./iconP10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6846a6d6",
  null
  
)

export default component.exports